<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="content">
        <div class="header">Fees</div>
      </div>
    </div>
    <div class="ui attached segment">
      <div class="ui form">
        <div class="ui field">
          <label>Platform Fees</label>
          <div class="ui labeled input">
            <div class="ui label">%</div>
            <input v-model="platformFee" v-on:change="handleSelected" />
          </div>
        </div>
        
        <div v-if="showManagementFees" class="ui field">
          <label>Inv Man fees</label>
          <div class="ui labeled input">
            <div class="ui label">%</div>
            <input v-model="managementFees" v-on:change="handleSelected" />
              </div>
          <div style="font-size: 10px;" v-if="maxFees != ''">Max {{maxFees}} pa</div>

        </div>
        <div v-if="showAdvisoryFees" class="ui field">
          <label>Advisory Fees</label>
          <div class="ui labeled input">
            <div class="ui label">%</div>
            <input v-model="advisorFee" v-on:change="handleSelected" />
          </div>
        </div>
        <div class="ui field">
          <label>Other Fees</label>
          <div class="ui labeled input">
            <div class="ui label">%</div>
            <input v-model="otherCharges" v-on:change="handleSelected" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";

import {} from "@/gateway";
export default {
  name: "Testing",
  components: { vSelect, VueSlider },
  props: [
    "platformFee",
    "advisorFee",
    "otherCharges",
    "showAdvisoryFees",
    "managementFees",
    "selectedPortfolio",
  ],
  data() {
    return {};
  },
  computed: {
    maxFees() {
      if (this.selectedPortfolio) {
      
        var containsWAAM = this.selectedPortfolio.portfolioName.includes(
            "WAAM"
        );
        var isSimonSayer = this.selectedPortfolio.riskProfile.partnerId == 160|| this.selectedPortfolio.riskProfile.partnerId == 167;
        // warren moved to quest only. so cannot amend inv fee.
        if (isSimonSayer)
          return "1%";
        if (containsWAAM)
          return "2%";
        if (
            this.selectedPortfolio.riskProfile.partnerId == 18 &&
            (containsGlobal || containsSharePortfolio)
        )
          return "";
        else     return "";
      } else {
        return "";
      }
    },
    showManagementFees() {
      if (this.selectedPortfolio) {
        var containsSharePortfolio = this.selectedPortfolio.portfolioName.includes(
          "Share"
        );
        var containsGlobal = this.selectedPortfolio.portfolioName.includes(
          "Global"
        );
        var containsWAAM = this.selectedPortfolio.portfolioName.includes(
            "WAAM"
        );
        var isSimonSayer = this.selectedPortfolio.riskProfile.partnerId == 160|| this.selectedPortfolio.riskProfile.partnerId == 167;
        // warren moved to quest only. so cannot amend inv fee.
        if (isSimonSayer)
          return true;
        if (containsWAAM)
          return true;
        if (
          this.selectedPortfolio.riskProfile.partnerId == 18 &&
          (containsGlobal || containsSharePortfolio)
        )
          return true;
        else return false;
      } else {
        return false;
      }
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },

    async handleSelected(selected) {
      this.$emit("handleSelected", {
        advisorFee: this.advisorFee,
        platformFee: this.platformFee,
        otherCharges: this.otherCharges,
        managementFees: this.managementFees,
      });
    },
    updateProjection() {
      this.$emit("updateProjection");
    },

    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
